import React, { PureComponent } from 'react';
import { Col, Container, Row, Modal, ButtonToolbar } from 'reactstrap';
import CountofUniqueSKUs from '../Booking/components/CountofUniqueSKUs';
import FastMovingLast from '../Booking/components/FastMovingLast';
import Customizer from '../../Layout/customizer/Customizer';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import reportData from './dynamic';
import staticData from './static';
import API from "../../Common/api";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSyncAlt } from "@fortawesome/free-solid-svg-icons";
import LoadingOverlay from 'react-loading-overlay';
import { message } from 'antd';

var url = window.location.hostname;
var port = window.location.port;

class DefaultDashboard extends PureComponent {
  constructor() {
    super();
    this.state = {
      items: [],
      static_items: [],
      data_render: false,
      data_dynamic_render: false,
      all_apis: [],
      all_dynamic_apis: [],
      isOn: false,
      isdisabled: false,
      display_type: 'none',
      success_modal: false,
      failed_modal : false,
      message : ""
    }
  }

  componentWillMount() {
    this.toggleAutomation()
  }

  getListStyle = isDraggingOver => ({
    overflow: 'hidden',
  });

  successtoggle= () => {
    this.setState(prevState => ({ success_modal: !prevState.success_modal }));
  }
  Failedtoggle= () => {
    this.setState(prevState => ({ failed_modal: !prevState.failed_modal }));
  }
  toggleAutomation = () => {
    const loc = this.getCookie('tezz_warehouse')
    
    if (loc == "true") {
      API.post('/location/enable-automation/',{param : {"request_type":"validate"}})
      .then((response) => response.data)

      .then((data) => {
        if (data.message === "Saleable Automation already enabled") {
          this.setState({ isOn: true,
            isdisabled: true,
            display_type: 'flex' ,
            message : data.message,
            // success_modal :true
          })
        }
        else if (data.message === "Saleable Automation not enabled"){
          this.setState({ isOn: false,
            isdisabled: false,
            display_type: 'flex' ,
            message : data.message,
            // failed_modal :true
          })
        }
        else{
          this.setState({ isOn: false,
            isdisabled: false,
            display_type: 'flex'
          })
        }
      })
    } else {
      this.setState({
        isdisabled: true,
        display_type: 'none'
      })
    }
  }
  getAllTiles = (tile_type, tile_data) => {
    var json_data = [];
    const payload = {
      "tile_type": tile_type,
      "tile_data": tile_data,
    };

    API.post('/reports/json_func/v1/', { param: payload })
      .then((response) => {
        json_data = response.data.json_data;
      }).then((response) => {
        if (tile_type == "dynamic") {
          reportData.items = json_data;
          this.setState({
            items: reportData.items
          });
          this.DashboardCount();
        }

        if (tile_type == "static") {
          staticData.items = json_data;
          this.setState({ static_items: staticData.items });
          this.StaticDashboardCount();
        }
      })
  }

  onDragEnd = result => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const items = Array.from(this.state.items);
    const [removed] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, removed);

    this.getAllTiles("dynamic", JSON.stringify(items));
    this.setState({
      items
    });
  }

  onStaticDragEnd = result => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const static_items = Array.from(this.state.static_items);
    const [removed] = static_items.splice(result.source.index, 1);
    static_items.splice(result.destination.index, 0, removed);

    this.getAllTiles("static", JSON.stringify(static_items));
    this.setState({
      static_items
    });
  }

  DashboardCount = () => {
    const items = this.state.items;
    var api_count = 0
    this.state.items.map((report_obj, index) => {
      if (report_obj.show == true) {
        api_count += 1;
      }
    });
    this.state.items.map((report_obj, index) => {
      if (report_obj.show == true) {
        const payload = {
          "location": this.getCookie('selectedLocation'),
          "report_type": report_obj.report_type,
          "report_detailed": ""
        };

        API.post(report_obj.url, { param: payload })
          .then((response) => {
            if (response.data.count == undefined || response.data.count == "null") {
              if (response.data.sum == undefined || response.data.details == "null") {
                if (response.data.details == undefined || response.data.details == "null") {
                  items[index].data_count = 0 + report_obj.data_unit;
                } else {
                  items[index].data_count = response.data.details + report_obj.data_unit;
                }
              } else {
                items[index].data_count = response.data.sum + report_obj.data_unit;
              }
            } else {
              items[index].data_count = response.data.count + report_obj.data_unit;
            }
          },
            (error) => {
              items[index].data_count = 0 + report_obj.data_unit;
            }).then((response) => {
              this.state.all_dynamic_apis.push(report_obj.id);
              this.setState({ items });

              if (this.state.all_dynamic_apis.length >= api_count) {
                this.setState({ data_dynamic_render: true })
              }

            })
      }
    });
  }

  DynamicTileToggle = () => {
    this.setState({
      items: reportData.items
    });

    this.getAllTiles("dynamic", "");
  }

  StaticTileToggle = () => {
    this.setState({
      static_items: staticData.items
    });

    this.getAllTiles("static", "");
  }

  StaticDashboardCount = () => {
    const static_items = this.state.static_items;
    var api_count = 0;
    this.state.static_items.map((report_obj, index) => {
      if (report_obj.show == true) {
        api_count += 1;
      }
    });

    this.state.static_items.map((report_obj, index) => {
      if (report_obj.show == true) {
        const payload = {
          "location": this.getCookie('selectedLocation'),
          "report_type": report_obj.report_type,
          "report_detailed": ""
        };

        API.post(report_obj.url, { param: payload })
          .then((response) => {
            if (response.data.data.length > 0) {
              if (report_obj.report_type == "PickingProductivity") {
                console.log(response.data.data);
                var last_index = response.data.data.length - 1;
                if (response.data.data[last_index].avg == undefined) {
                  static_items[index].data_count = 0 + report_obj.data_unit
                } else {
                  var avg = Math.round(response.data.data[last_index].avg, 2);
                  static_items[index].data_count = avg + report_obj.data_unit;
                }
              } else {
                if (response.data.data[0].count == undefined || response.data.data[0].count == "null") {
                  if (response.data.data[0].sum == undefined || response.data.data[0].sum == "null") {
                    if (response.data.data[0].details == undefined || response.data.data[0].details == "null") {
                      if (report_obj.report_type == "ValueInventory") {
                        static_items[index].data_count = report_obj.data_unit + " " + 0;
                      } else {
                        static_items[index].data_count = 0 + report_obj.data_unit;
                      }
                    } else {
                      if (report_obj.report_type == "ValueInventory") {
                        static_items[index].data_count = report_obj.data_unit + " " + response.data.data[0].details;
                      } else {
                        static_items[index].data_count = response.data.data[0].details + report_obj.data_unit;
                      }
                    }
                  } else {
                    if (report_obj.report_type == "VolumeAvailable") {
                      if (response.data.data[0].total_volume == undefined || response.data.data[0].total_volume == "") {
                        static_items[index].data_count = response.data.data[0].sum
                      } else {
                        static_items[index].data_count = response.data.data[0].sum + " (" + response.data.data[0].total_volume + ")";
                      }
                    } else {
                      static_items[index].data_count = response.data.data[0].sum + report_obj.data_unit;
                    }
                  }
                } else {
                  if (report_obj.report_type == "ValueInventory") {
                    static_items[index].data_count = report_obj.data_unit + " " + response.data.data[0].count;
                  } else {
                    static_items[index].data_count = response.data.data[0].count + report_obj.data_unit;
                  }
                }
              }
            } else {
              if (report_obj.report_type == "ValueInventory") {
                static_items[index].data_count = report_obj.data_unit + " " + 0;
              } else {
                static_items[index].data_count = 0 + report_obj.data_unit;
              }
            }
          }, (error) => {
            if (report_obj.report_type == "ValueInventory") {
              static_items[index].data_count = report_obj.data_unit + " " + 0;
            } else {
              static_items[index].data_count = 0 + report_obj.data_unit;
            }
          }).then((response) => {
            this.state.all_apis.push(report_obj.id);
            this.setState({ static_items });
            if (this.state.all_apis.length >= api_count) {
              this.setState({ data_render: true })
            }
          });
      }
    });
  }

  getCookie(cname) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  componentDidMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090"
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088"
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8090";
    } else {
      url = window.location.hostname + port;
    }

    // this.getAllTiles("dynamic","",1);
    // this.getAllTiles("static","",1);
  }

  accessCookie = (cookieName) => {
    var name = cookieName + "=";
    var allCookieArray = document.cookie.split(';');
    for (var i = 0; i < allCookieArray.length; i++) {
      var temp = allCookieArray[i].trim();
      if (temp.indexOf(name) == 0)
        return temp.substring(name.length, temp.length);
    }
    return "";
  }
  toggle = () => {
    this.setState({
      isdisabled : true
    })
    API.post("/location/enable-automation/",{param : {"request_type":"update"}})
      .then((response) => response.data)

      .then((data) => {
        if (data.success) {
          this.setState({ isOn: true, isdisabled : true , message : data.message, success_modal: true })
        }

        else if (!data.success) {
          this.setState({ isOn: false, isdisabled : false , message : data.message, failed_modal: true })
        }
      })
  }

  render() {
    const { success_modal, failed_modal } = this.state;
    return (



      <Container className="dashboard">

        {this.state.data_render ? <Customizer
          dynamic_tile_toggle={this.DynamicTileToggle}
          static_tile_toggle={this.StaticTileToggle}
          static_items={this.state.static_items} items={this.state.items}
        /> : <LoadingOverlay active={false} spinner text='' />
        }
        <Row>
          <Col md={8}>
            <h3 className="page-title">Dashboard</h3>
          </Col>
          <Col md={3}>
            <div style={{ padding: '0px', textAlign: 'center', display: this.state.display_type }}>
              <p style={{ marginRight: "5px", fontSize: '14px' }}>Saleable Automation</p>
              <button
                onClick={this.toggle}
                disabled={this.state.isdisabled}
                style={{
                  margin: 'opx 5px 0px 15px',
                  padding: '5px 10px',
                  fontSize: '12px',
                  cursor: 'pointer',
                  backgroundColor: this.state.isOn ? 'green' : '#FBBB00',
                  color: 'white',
                  border: 'none',
                  borderRadius: '1px',
                  transition: 'background-color 0.3s ease',
                }}
              >
                {this.state.isOn ? 'ON' : 'Turn on'}
              </button>
            </div>
          </Col>
          <Col md={1}>
            <span
              className="pull-right"
              onClick={() => { window.location.reload() }}
              style={{ fontSize: '20px', paddingRight: '52px', cursor: 'pointer', color: '#919193' }}
            >
              <FontAwesomeIcon icon={faSyncAlt}></FontAwesomeIcon>
            </span>
          </Col>
        </Row>

        <DragDropContext onDragEnd={this.onDragEnd}>
          {
            <Droppable droppableId="column-1" direction="horizontal">
              {(provided, snapshot) => (
                <div
                  className="row"
                  ref={provided.innerRef}
                  {...provided.droppableProps}
                >
                  {this.state.data_dynamic_render &&
                    this.state.items.map((report_obj, index) => <FastMovingLast key={index} drag_id={report_obj.id} index={index} report_obj={report_obj} />)}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          }
        </DragDropContext>


        <DragDropContext onDragEnd={this.onStaticDragEnd}>
          {
            <Droppable droppableId="column-2" direction="horizontal">
              {(provided, snapshot) => (
                <div
                  className="row"
                  ref={provided.innerRef}
                  style={this.getListStyle(snapshot.isDraggingOver)}
                  {...provided.droppableProps}
                >
                  {this.state.data_render &&
                    this.state.static_items.map((report_obj, index) => <CountofUniqueSKUs key={index} drag_id={report_obj.id} index={index} report_obj={report_obj} />)
                  }
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          }
        </DragDropContext>
        <Modal
                  isOpen={success_modal}
                  toggle={this.successtoggle}
                >
                  <div className="modal__header">
                    <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.successtoggle} />
                  </div>
                  <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
                    <span className="lnr lnr-thumbs-up modal__title-icon" style={{color: '#4ce1b6'}} />
                    <h4>{this.state.message} </h4>
                  </div>
                  <ButtonToolbar className="modal__footer">
                    <button
                className="modal_ok"
                onClick={this.successtoggle}
                style={{backgroundColor: '#FBBB00', color: '#fff'}} 
              >
                Ok
              </button>
                  </ButtonToolbar>
                </Modal>
                <Modal
                  isOpen={failed_modal}
                  toggle={this.Failedtoggle}
                >
                  <div className="modal__header">
                    <button className="lnr lnr-cross modal__close-btn" type="button" style={{right: 15}} onClick={this.Failedtoggle} />
                  </div>
                  <div className="modal__body" style={{paddingTop: 55, paddingBottom: 20}}>
                    <span className="lnr lnr-cross-circle modal__title-icon" style={{color: 'red'}} />
                    <h4>{this.state.message} </h4>
                  </div>
                  <ButtonToolbar className="modal__footer">
                    <button
                className="modal_ok"
                onClick={this.Failedtoggle}
                style={{backgroundColor: '#FBBB00', color: '#fff'}} 
              >
                Ok
              </button>
                  </ButtonToolbar>
                </Modal>

      </Container>

    )
  }
}

export default DefaultDashboard;
